import {createStyles} from '@mantine/core';
import {NavLink} from "react-router-dom";

const useStyles = createStyles((theme) => ({
    control: {
        // "-webkit-box-align": 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        fontSize: '11px',
        height: '70px',
        // "-webkit-box-pack": 'center',
        justifyContent: 'center',
        lineHeight: '1.15',
        margin: '0px',
        outlineStyle: 'none',
        padding: '7px',
        position: 'relative',
        textDecoration: 'none',
        width: '80px',
        borderLeft: '4px solid transparent',
        color: 'rgb(103, 118, 138)',

        'span': {
            marginTop: 7,
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },

        '&:hover': {
            color: theme.colors.gray[7],
        },
    },
    active_control: {
        borderColor: '#a70535'
    }
}));

export function LinksGroup({icon: Icon, label, link, links, setSubLinks}: any) {
    const {classes} = useStyles();

    const onSelectedRoute = () => {
        if (links) setSubLinks(links)
        else setSubLinks([])
    }
    return <NavLink
        to={link}
        className={({isActive}) =>
            isActive ? classes.control + ' ' + classes.active_control : classes.control
        }
        onClick={() => onSelectedRoute()}>
        <Icon size={26} strokeWidth={1.4}/>
        <span>{label}</span>
    </NavLink>
}
